import { PLUGIN } from "_constants/request.constants";
import { reduxActions as PHOTOTOOL } from "../phototool.constants";

export const pc9Fetch = (data, extras = {}) => (dispatch) => dispatch({
  [PLUGIN]: {
    types: [PHOTOTOOL.FETCH_PC9_STARTED, PHOTOTOOL.FETCH_PC9_SUCCESS, PHOTOTOOL.FETCH_PC9_FAIL],
    endpoint: '/plugin/phototool/pc9/update',
    reqType: 'POST',
    data,
    ...extras
  }
});
